import { makeCloudFunction } from "../makeCloudFunction";
import { SearchUsersRequest, SearchUsersResponse } from "@functions-types";

export const searchUsers = makeCloudFunction<
  SearchUsersRequest,
  SearchUsersResponse
>("user", "searchUsers");
